// extracted by mini-css-extract-plugin
var _1 = "Any0E";
export { _1 as "tabs" }
